var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign"},[_c('div',{staticClass:"sign_block flex_v"},[_c('h4',{staticClass:"eng"},[_vm._v(_vm._s(_vm.engTitle))]),_c('h4',{staticClass:"tw"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }